import { useRequestEvent } from '#app'
import { setResponseStatus } from 'h3'
import { usePreview } from './usePreview'

type PageBuilderEntry = {
  hero?: unknown[]
  pageBuilder?: unknown[]
} | null | undefined

export function hasPageBuilderContent(page: PageBuilderEntry): boolean {
  return Boolean(page?.hero?.length || page?.pageBuilder?.length)
}

export function assertPageFound(isMissing: boolean, uri?: string): void {
  if (!isMissing) {
    return
  }

  const { isPreview } = usePreview()
  if (isPreview.value) {
    return
  }

  if (import.meta.server) {
    const event = useRequestEvent()
    if (event) {
      setResponseStatus(event, 404, 'Page Not Found')
    }
  }

  if (import.meta.prerender && uri) {
    console.warn(`[prerender] Page not found: ${uri}`)
  }
}
